import Event from "components/Event"
import { ActivityIndicator } from "components/activity-indicator"
import { EmptyState } from "components/empty-state"
import useCurrent from "lib/use-current"
import ConventionRegistration from "models/convention-api/v1/ConventionRegistration"

interface IItineraryEvents {
  conventions: ConventionRegistration[]
}

export const ItineraryEvents = (props: IItineraryEvents) => {
  const current = useCurrent()
  // @ts-ignore
  const { config: providerConfig } = current

  if (!providerConfig) {
    return <ActivityIndicator />
  }

  if (props.conventions.length === 0) {
    return <EmptyState title="🎟" subtitle="You aren’t registered for any upcoming fairs" large />
  } else {
    return (
      <>
        {props.conventions.map(({ id, convention }) =>
          convention ? <Event key={id} convention={convention} /> : null,
        )}
      </>
    )
  }
}
